var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack } from "@eightfold.ai/octuple";
import React from "react";
import styles from "./DistributionSet.module.css";
import { InnerLabeledDonutChart } from "./DonutChart";
var Descriptor = function (_a) {
    var text = _a.text, color = _a.color;
    return (_jsxs(Stack, __assign({ gap: "m", className: styles.descriptor, justify: "flex-start", direction: "horizontal" }, { children: [_jsx("div", { className: styles.circle, style: {
                    borderColor: color.border,
                    backgroundColor: color.background,
                } }), _jsx("div", __assign({ className: styles.description }, { children: text }))] })));
};
export var getWithBucketDescriptionTexts = function (buckets) {
    var total = buckets.reduce(function (total, _a) {
        var count = _a.count;
        return total + Number(count);
    }, 0);
    return buckets.map(function (previous) { return (__assign(__assign({}, previous), { text: "".concat(previous.count, " (").concat(Math.round((100 * previous.count) / total), "%)") })); });
};
export var getDescriptionWithTexts = function (buckets) {
    var total = buckets.reduce(function (total, _a) {
        var count = _a.count;
        return total + Number(count);
    }, 0);
    return buckets.map(function (previous) { return (__assign(__assign({}, previous), { text: (_jsxs(_Fragment, { children: [_jsxs("div", { children: [previous.count, " ", previous.text] }), _jsxs("div", { children: ["(", Math.round((100 * previous.count) / total), "%)"] })] })) })); });
};
export var DistributionSet = function (_a) {
    var buckets = _a.buckets, label = _a.label, radius = _a.radius, margin = _a.margin;
    var filteredBuckets = buckets.filter(function (bucket) { return bucket.count > 0; });
    return (_jsxs(Stack, __assign({ gap: "xl", direction: "horizontal" }, { children: [_jsx(Stack, __assign({ align: "center", direction: "vertical", justify: "space-around" }, { children: _jsx(InnerLabeledDonutChart, { margin: margin || 70, label: label, radius: radius, counts: filteredBuckets, thickness: 12, gap: 0.04 }) })), _jsx(Stack, __assign({ className: styles.legend, align: "center", direction: "vertical", justify: "space-between" }, { children: filteredBuckets.map(function (_a, index) {
                    var text = _a.text, color = _a.color;
                    return (_jsxs(_Fragment, { children: [index != 0 && _jsx("div", { className: styles.line }), _jsx(Descriptor, { text: text, color: color })] }));
                }) }))] })));
};
